var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    'dp-checkbox',
    ("dp-checkbox--size-" + _vm.size),
    {
      'dp-checkbox--disabled': _vm.isDisabled,
      'dp-checkbox--checked': _vm.isChecked,
      'dp-checkbox--block': _vm.block,
    }
  ],attrs:{"aria-checked":_vm.isChecked,"aria-disabled":_vm.isDisabled}},[_c('span',{class:[
      'dp-checkbox__input',
      {
        'dp-checkbox__input--checked': _vm.isChecked,
        'dp-checkbox__input--disabled': _vm.isDisabled,
      }
    ],attrs:{"aria-checked":"mixed"}},[_c('span',{class:[
        'dp-checkbox__inner',
        {
          'dp-checkbox__inner--checked': _vm.isChecked,
          'dp-checkbox__inner--focus': _vm.focus,
          'dp-checkbox__inner--disabled': _vm.isDisabled,
        }
      ]}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],staticClass:"dp-checkbox__original",attrs:{"disabled":_vm.disabled,"type":"checkbox"},domProps:{"value":_vm.val,"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.val)>-1:(_vm.model)},on:{"click":function($event){return _vm.$emit('click')},"change":[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.val,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}},function($event){return _vm.handleChange()}],"focus":function($event){_vm.focus = true},"blur":function($event){_vm.focus = false}}}),(_vm.$slots.default || _vm.label)?_c('span',{staticClass:"dp-checkbox__label"},[_vm._t("default"),(_vm.label)?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }